import { TranslateService } from '@ngx-translate/core';

import { inject } from '@angular/core';

import { type ActionFactory } from '@shared/utils/entity-actions';

import type { Firm } from '../models';
import { FirmPolicy } from '../firm-policy';

export function injectFirmActions() {
  const translate = inject(TranslateService);
  const policy = inject(FirmPolicy);

  return {
    edit: (command) => ({
      icon: 'edit',
      label: translate.instant('common.actions.edit'),
      visible: (firm) => policy.canEdit(firm),
      command,
    }),
    delete: (command) => ({
      icon: 'trash',
      color: 'danger',
      label: translate.instant('common.actions.delete'),
      visible: (firm) => policy.canDelete(firm),
      command,
    }),
  } satisfies Record<string, ActionFactory<Firm>>;
}
